import {
  type AdminGetExamCenterMemberByIdQuery,
  type GetExamCenterMemberByIdQuery,
} from '@exam-center/graphql';

import { type ExamCenterMemberStatus } from '../../constants';
import { type ExamCenterMemberDetailsData } from '../../types';

type ExamCenterMemberData =
  | GetExamCenterMemberByIdQuery['ecGetExamCenterMemberById']['examCenterMember']
  | AdminGetExamCenterMemberByIdQuery['ecAdminGetExamCenterMemberById']['examCenterMember'];

export function mapExamCenterMemberData(
  examCenterMemberData: ExamCenterMemberData | undefined,
): ExamCenterMemberDetailsData {
  const firstName = examCenterMemberData?.user?.firstname ?? '';
  const lastName = examCenterMemberData?.user?.lastname ?? '';
  const email = examCenterMemberData?.user?.email ?? '';
  const appRoles = examCenterMemberData?.user?.appRoles ?? [];
  const status = examCenterMemberData?.user?.status as ExamCenterMemberStatus;
  const createdAt = examCenterMemberData?.user?.createdAt ?? '';
  const lastLoginAt = examCenterMemberData?.user?.lastLoginAt ?? '';

  return {
    fullName: `${firstName} ${lastName}`,
    firstName,
    lastName,
    email,
    appRoles,
    status,
    createdAt,
    lastLoginAt,
  };
}
